import moment from 'moment-timezone';

const CallBookingQueryParams = {
  LeadId: 'leadId',
  Name: 'name',
  TimeZone: 'timeZone',
};

const REQUIRED_PARAMS = Object.values(CallBookingQueryParams);

/**
 * Parses the query parameters from the URL and returns an object with the parsed parameters.
 * @param {URLSearchParams} params - The URL search parameters.
 * @returns {Object} An object with the parsed parameters.
 */
const parseQuery = (params) => ({
  leadId: params.get(CallBookingQueryParams.LeadId) || '',
  name: params.get(CallBookingQueryParams.Name) || '',
  timeZone: params.get(CallBookingQueryParams.TimeZone) || moment.tz.guess(),
});

const getSlotSeatsAvailability = async (remote, start, end, timezone) => {
  const params = new URLSearchParams();
  params.append('start', start);
  params.append('end', end);
  params.append('timezone', timezone);

  const response = await remote(`calDotCom-getSlotsAvailability?${params.toString()}`, null, { method: 'GET' }, true);
  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.error || 'Failed to fetch slots availability');
  }
  return result.data;
};

const bookLeadCall = async (remote, start, leadId) => {
  const response = await remote('calDotCom-bookLeadCall', { start, leadId }, { method: 'POST' }, true);
  const result = await response.json();
  if (!response.ok) {
    return { success: false, error: result?.error || 'Failed to book the call' };
  }
  return result;
};

const getLeadDetails = async (remote, leadId) => {
  const response = await remote('lead-getLeadDetails', { leadId }, { method: 'POST' }, true);
  const result = await response.json();
  if (!response.ok) {
    return { success: false, error: result?.error || 'Failed to get lead details' };
  }
  return result.data;
};

export {
  parseQuery,
  REQUIRED_PARAMS,
  getSlotSeatsAvailability,
  bookLeadCall,
  CallBookingQueryParams,
  getLeadDetails,
};
